var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"id":'item-' + _vm.itemId,"label":_vm.consulta,"label-for":"rating","label-cols":_vm.labelCols,"horizontal":""}},[_c('div',{staticClass:"rating"},[_c('div',{staticClass:"star"},[_c('i',{class:{  
                  'fa': true,
                  'fa-star': _vm.calificacion >= 1 ? true : false,
                  'fa-star-o': _vm.calificacion < 1 ? true : false,
                  'disabled': _vm.readOnly ? true : false
                  },on:{"click":function($event){return _vm.setCalificacion(1)}}})]),_c('div',{staticClass:"star"},[_c('i',{class:{  
                  'fa': true,
                  'fa-star': _vm.calificacion >= 2 ? true : false,
                  'fa-star-o': _vm.calificacion < 2 ? true : false, 
                  'disabled': _vm.readOnly ? true : false
                  },on:{"click":function($event){return _vm.setCalificacion(2)}}})]),_c('div',{staticClass:"star"},[_c('i',{class:{  
                  'fa': true,
                  'fa-star': _vm.calificacion >= 3 ? true : false,
                  'fa-star-o': _vm.calificacion < 3 ? true : false, 
                  'disabled': _vm.readOnly ? true : false
                  },on:{"click":function($event){return _vm.setCalificacion(3)}}})]),_c('div',{staticClass:"star"},[_c('i',{class:{  
                  'fa': true,
                  'fa-star': _vm.calificacion >= 4 ? true : false,
                  'fa-star-o': _vm.calificacion < 4 ? true : false, 
                  'disabled': _vm.readOnly ? true : false
                  },on:{"click":function($event){return _vm.setCalificacion(4)}}})]),_c('div',{staticClass:"star"},[_c('i',{class:{  
                  'fa': true,
                  'fa-star': _vm.calificacion >= 5 ? true : false,
                  'fa-star-o': _vm.calificacion < 5 ? true : false, 
                  'disabled': _vm.readOnly ? true : false
                  },on:{"click":function($event){return _vm.setCalificacion(5)}}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }